(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("electron"), require("path"), require("child_process"), require("fs"), require("net"), require("tty"), require("util"));
	else if(typeof define === 'function' && define.amd)
		define(["electron", "path", "child_process", "fs", "net", "tty", "util"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("electron"), require("path"), require("child_process"), require("fs"), require("net"), require("tty"), require("util")) : factory(root["electron"], root["path"], root["child_process"], root["fs"], root["net"], root["tty"], root["util"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_69__, __WEBPACK_EXTERNAL_MODULE_257__, __WEBPACK_EXTERNAL_MODULE_259__, __WEBPACK_EXTERNAL_MODULE_260__, __WEBPACK_EXTERNAL_MODULE_261__, __WEBPACK_EXTERNAL_MODULE_262__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition